import type { ICommand } from '../../core/interfaces/Command';
import type { ToolStateStore } from '../ToolStateStore';
import { Tools } from '../ToolStateStore';

export class SetIndicationToolCommand implements ICommand {
  private readonly _toolsStateStore: ToolStateStore;

  private _previousTool: Tools | null = null;

  private _targetTool: Tools;

  public constructor(toolsStateStore: ToolStateStore, targetTool: Tools) {
    this._toolsStateStore = toolsStateStore;
    this._targetTool = targetTool;
  }

  public execute(): Promise<boolean> {
    this._previousTool = this._toolsStateStore.currentTool;
    this._toolsStateStore.setCurrentTool(this._targetTool);
    return Promise.resolve(true);
  }

  public undo(): Promise<boolean> {
    if (this._previousTool) {
      this._toolsStateStore.setCurrentTool(this._previousTool);
      return Promise.resolve(true);
    } else {
      this._toolsStateStore.setCurrentTool(Tools.NONE);
    }
    return Promise.resolve(false);
  }
}
